<div>{{ geoResultOptions.length | i18nPlural: i18nPluralMessage | transloco }}</div>
<ng-container *ngFor="let option of geoResultOptions">
  <avn-radio type="text" [value]="option.value" [label]="option.label" (change)="selectedLocation = option.data"> </avn-radio>
</ng-container>
<div>{{ 'siteManagementScope.SITE_MANAGEMENT.SYNC_SITES.ADDRESS_SELECTOR.KEEP_VALUE_PROVIDED_50' | transloco }}</div>
<avn-radio type="text" [label]="siteLocation" [value]="siteLocation" (change)="selectedLocation = null"> </avn-radio>
<avn-button [avnTheme]="'primary'" [label]="'button.save' | transloco" [disabled]="selectedLocation === undefined" (actioned)="onSelectLocation()"> </avn-button>
